Ext.define('SA.view.RankingToolbar', {
    extend: 'SA.view.Toolbar',

    initComponent() {
        this.items = [
            {
                xtype: 'combo-button',
                itemId: 'topNCombo',
                items: [10, 100, 1000, 10000],
                margin: '0 10 0 0',
                textTpl: 'Top {.}',
                ui: 'underline'
            }, {
                xtype: 'combo-button',
                itemId: 'unitCombo',
                textField: 'name',
                ui: 'underline',
                valueField: 'id'
            }, {
                xtype: 'pvt-text',
                text: 'in'
            }, {
                xtype: 'pvt-location-dropdown',
                itemId: 'locationDropdown'
            }, {
                xtype: 'pvt-text',
                text: 'sorted by'
            }, {
                xtype: 'combo-button',
                emptyText: 'Location Name',
                itemId: 'sortCombo',
                textTpl: '{name}, {year}',
                ui: 'underline'
            }, {
                xtype: 'pvt-fill'
            }, {
                xtype: 'pvt-filtering-button',
                itemId: 'filteringButton',
                margin: '0 10 0 0'
            }, {
                xtype: 'pvt-view-actions-button',
                itemId: 'viewActionsButton',
                margin: '0 10 0 0'
            }, {
                xtype: 'pvt-ranking-export-button',
                margin: '0 10 0 0'
            }
        ];

        this.callParent();

        this.exportBtn = this.down('pvt-ranking-export-button');

        this.topNCombo = this.down('#topNCombo');
        this.unitCombo = this.down('#unitCombo');
        this.locationDropdown = this.down('#locationDropdown');
        this.sortCombo = this.down('#sortCombo');
        this.filteringButton = this.down('#filteringButton');
        this.viewActionsButton = this.down('#viewActionsButton');

        this.filteringButton.setMenuCfg(this.filteringMenuCfg);

        this.viewActionsButton
            .setProjectView(this.model)
            .addEditItem()
            .addSeparator()
            .addDeleteItem();
    },

    initEvents() {
        this.callParent();

        this.topNCombo.on('change', this.onTopNComboChange, this);
        this.unitCombo.on('change', this.onUnitComboChange, this);
        this.locationDropdown.on('change', this.onLocationDropdownChange, this);
        this.sortCombo.on('change', this.onSortComboChange, this);
    },

    onLocationDropdownChange(dropdown, location) {
        this.fireEvent('change:location', location);
    },

    onSortComboChange(combo, sort) {
        this.fireEvent('change:sort', sort);
    },

    onTopNComboChange(combo, value) {
        this.fireEvent('change:topN', value);
    },

    onUnitComboChange(combo, unit) {
        this.fireEvent('change:unit', unit);
    },

    setState(state) {
        var {topNValue, unitItems, unitValue, locationItems, locationValue, sortItems, sortValue, filtered} = state;

        this.topNCombo.setValue(topNValue);
        this.unitCombo.setItemsAndValue(unitItems, unitValue);
        this.locationDropdown.setItemsAndValue(locationItems, locationValue);
        this.sortCombo.setItemsAndValue(sortItems, sortValue);
        this.filteringButton.setIndicatorVisible(filtered);
    }
});